import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PastMedicationService } from 'src/app/services/past-medication.service';

@Component({
  selector: 'app-update-pastmedication',
  templateUrl: './update-pastmedication.component.html',
  styleUrls: ['./update-pastmedication.component.css'],
})
export class UpdatePastmedicationComponent implements OnInit {
  isSuccess = false;

  id = 0;
  states;
  constructor(
    private fb: UntypedFormBuilder,
    private pastMedicationService: PastMedicationService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      this.id = res['id'];
    });

    this.pastMedicationService
      .getPastMedicationById(this.id)
      .subscribe((res) => {
        this.Frm.patchValue(res);
      });
  }

  Frm = this.fb.group({
    DrugName: ['', Validators.required],
    Dosage: ['', Validators.required],
    StartDate: ['', Validators.required],
    DrugCode: ['', Validators.required],
    EndDate: ['', Validators.required],
    // Status: [''],
  });

  get EndDate() {
    return this.Frm.get('EndDate');
  }

  get DrugName() {
    return this.Frm.get('DrugName');
  }

  get Dosage() {
    return this.Frm.get('Dosage');
  }
  get StartDate() {
    return this.Frm.get('StartDate');
  }

  // get Status() {
  //   return this.Frm.get('Status');
  // }

  formSubmit() {
    let endDate = this.Frm.value['EndDate'];
    let drugName = this.Frm.value['DrugName'];
    let dosage = this.Frm.value['Dosage'];

    let startDate = this.Frm.value['StartDate'];

    // let status = this.Frm.value['Status'];

    let body = {
      DrugName: drugName,
      Dosage: dosage,
      StartDate: startDate,
      EndDate: endDate,
      // Status: status,
    };

    this.pastMedicationService
      .updatePastMedication(this.id, body)
      .subscribe((res) => {
        this.isSuccess = true;
        this.Frm.reset();
      });
  }
}
